module.exports = __webpack_public_path__ + "static/pic01-11f396868a54626ad44b79230343538c.jpg";